import React from 'react';

import { RoutesContext } from '@confluence/route-manager/entry-points/RoutesContext.ts';
import { isEmbeddedRovoSystemSpaceAccessAllowed } from '@confluence/route-manager/entry-points/isEmbeddedRovoSystemSpaceAccessAllowed.ts';
import { isRovoSystemSpaceKey } from '@confluence/route-manager/entry-points/isRovoSystemSpaceKey.ts';
import { useIsEditorPage } from '@confluence/route-manager/entry-points/useIsEditorPage.ts';
import { NotFound } from '@confluence/not-found/entry-points/NotFound.ts';
import { fg } from '@confluence/feature-gating';

type WithRovoSystemSpaceNotFoundProps = {
	spaceKey: string;
};

export const withRovoSystemSpaceNotFound = <T extends WithRovoSystemSpaceNotFoundProps>(
	Component: React.ComponentType<T>,
): React.ComponentType<T> => {
	return (props: T) => {
		const { location } = React.useContext(RoutesContext);
		const isEditorPage = useIsEditorPage();
		const isEmbeddedRovoSystemSpaceAllowed = isEmbeddedRovoSystemSpaceAccessAllowed({
			isEditorPage,
			location,
		});

		// eslint-disable-next-line confluence-feature-gating/no-preconditioning
		if (
			isRovoSystemSpaceKey(props.spaceKey) &&
			!isEmbeddedRovoSystemSpaceAllowed &&
			fg('aifc_create_enabled')
		) {
			return <NotFound />;
		}
		return <Component {...props} />;
	};
};
